export const LAUNDRY_DAY_ROUTES = '/waschtage*';
export const LAUNDRY_DAY_BASE_ROUTE = '/waschtage';
export const LAUNDRY_DAY_DETAIL_ROUTE = '/waschtage/details';
export const LAUNDRY_DAY_CANCELLATION_ROUTE = '/waschtage/stornieren';
export const LAUNDRY_DAY_BOOKING_ROUTE = '/waschtage/reservieren';
export const LAUNDRY_DAY_RESERVATION_ROUTE = '/waschtage/reservierungen';
export const LAUNDRY_DAY_REMOTE_OPENING_ROUTE = '/waschtage/fernoeffnung';
